import { createFileRoute, redirect } from "@tanstack/react-router";
import { getProvider, cleanProviderForDisplay, type Provider } from "@/data/heallexa";
import { buildProviderSlug, parseProviderParam } from "@/lib/provider-slug";
import { getProviderByPublicIdFn, getProviderByIdPrefixFn, getProviderByNpiFn } from "./-providers.$id.functions";
import { ClaimFlow } from "./claim";

export const Route = createFileRoute("/providers_/$id/claim")({
  loader: async ({ params }) => {
    const parsed = parseProviderParam(params.id);
    let provider: Provider | null = null;
    if (parsed.kind === "uuid") {
      provider = await getProvider(parsed.uuid);
    } else if (parsed.kind === "npi") {
      const row = await getProviderByNpiFn({ data: { npi: parsed.npi } });
      provider = row ? cleanProviderForDisplay(row as Provider) : null;
    } else if (parsed.kind === "public_id") {
      const row = await getProviderByPublicIdFn({ data: { publicId: parsed.publicId } });
      provider = row ? cleanProviderForDisplay(row as Provider) : null;
    } else if (parsed.kind === "slug") {
      const row = await getProviderByIdPrefixFn({ data: { prefix: parsed.shortId } });
      provider = row ? cleanProviderForDisplay(row as Provider) : null;
    }
    if (!provider) throw redirect({ to: "/browse" });

    const canonicalSlug = buildProviderSlug(provider);
    if (canonicalSlug && canonicalSlug !== params.id) {
      throw redirect({ to: "/providers/$id/claim", params: { id: canonicalSlug }, statusCode: 301 });
    }

    return { providerId: provider.id };
  },
  head: () => ({ meta: [{ title: "Claim your listing · Heallexa" }, { name: "robots", content: "noindex" }] }),
  component: ClaimRoute,
});

function ClaimRoute() {
  const { providerId } = Route.useLoaderData();
  return <ClaimFlow providerId={providerId} initialPlan="free" />;
}
